module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/parent-show/parent-show.component.scss
// module id = ./src/app/components/parent-show/parent-show.component.scss
// module chunks = main